// A copy of this also exists in inherits_from.coffee
// That's used on admin & old order form.
// Once we get rid of old order form, we should be able to get rid of that coffee file, make the admin version use this. Things to note when we do that:
//  1. Some things trigger simplero:inherit using the jquery event system. On admin, afaik we might be loading 2 jqueries. If things are being triggered from 1 and listened on another, that might not work.
//  2. The function here has changed it's signature. Instead of adding to $.fn.xx and using $.each, it's now a normal JS function. You need to account for this when calling it from onDomChanged.
import $ from 'jquery'

export function inheritsFrom(source, destination, options) {
  if (!options) {
    options = {}
  }
  const $destination = $(destination)
  const $source = $(source)
  let changed_manually = false
  let val_on_focus = null

  const getSourceVal = options.getSourceVal || defaultGetSourceVal

  const setDestVal = function (val) {
    const currentVal = $destination.val()

    // Always update the value and internal state first to maintain consistency
    $destination.val(val)
    val_on_focus = val

    // Skip triggering change event if value hasn't actually changed
    if (currentVal === val) return

    // Don't trigger change events during AJAX updates to prevent infinite loops
    // with submit-on-change forms
    if (options && !options.notify && !window.Simplero?.state?.isAjaxUpdating) {
      $destination.change()
    }
  }

  if (
    getSourceVal($source) !== $destination.val().trim() &&
    ($destination.is(':visible') || $destination.closest('.t-modal').length > 0)
  ) {
    changed_manually = true
  }

  $source.on('animationstart', (event) => {
    const animationName = event.originalEvent.animationName

    // Don't trigger change events during AJAX updates to prevent infinite loops
    // with submit-on-change forms
    if (
      (animationName == 'onAutoFillStart' ||
        animationName == 'onAutoFillCancel') &&
      !window.Simplero?.state?.isAjaxUpdating
    ) {
      // Only trigger change if the destination value would actually change
      // to prevent unnecessary form submissions on submit-on-change forms
      const sourceVal = getSourceVal($source)
      if ($destination.val() !== sourceVal) {
        $source.trigger('change')
      }
    }
  })

  $source.on(
    `simplero:inherit ${!options.transform ? 'change keyup' : 'blur'}`,
    function () {
      if (changed_manually) return

      const val = getSourceVal($source)
      if (!options.transform) {
        return setDestVal(val)
      }

      $.ajax({
        url: options.transform,
        data: { s: val },
        success: (data) => setDestVal(data.output),
        error: () => setDestVal(val),
      })
    }
  )

  $destination.focus(() => (val_on_focus = $destination.val()))

  $destination.blur(function () {
    const cur_val = $destination.val()
    if (cur_val === '') {
      changed_manually = false
    } else if (cur_val !== val_on_focus) {
      changed_manually = true
    }
  })
}

// You can override this by passing options for custom behavior to derive the source value from
const defaultGetSourceVal = ($source) => {
  return $source
    .map((index, elem) => $(elem).val())
    .get()
    .join(' ')
    .trim()
}

$.fn.inheritsFrom = function (source, options) {
  this.each(function () {
    inheritsFrom($(source), this, options)
  })
}

if (window.onDomChanged) {
  window.onDomChanged('[data-inherits-from]', function () {
    let inheritsFrom = () => {
      this.inheritsFrom(
        this.data('inherits-from'),
        this.data('inherits-from-options')
      )
    }

    // If the element is inside a modal, we need to wait for the modal to be shown or else it will always inherit the value
    const modal = this.closest('.js-modal')
    if (modal.length > 0) {
      modal[0].addEventListener('modal:shown', () => {
        inheritsFrom()
      })
    } else {
      inheritsFrom()
    }
  })

  window.onDomChanged('[data-inherits-from-object-picker]', function () {
    const objectPickerSelect = $(
      this.data('inherits-from-object-picker')
    ).closest('.js-object-picker-select')

    const attributeName = this.data('inherits-from-attribute')
    if (!attributeName)
      throw new Error(
        'Please specify data-inherits-from-attribute when using data-inherits-from-object-picker'
      )

    const options = this.data('inherits-from-options') || {}

    options.getSourceVal = function ($source) {
      let attributes = $source
        .find(
          '.js-object-picker-selected-item .js-object-picker-item-exposed-attributes'
        )
        .html()
        ?.trim()

      if (!attributes) return ''
      attributes = JSON.parse(attributes)
      return attributes?.[attributeName] || ''
    }

    this.inheritsFrom(objectPickerSelect, options)
  })
}
